import axios from 'axios';
export const boilerPlateIsActive = process.env.VUE_APP_DRAGON_TIGER_API
  ? true
  : false;
const API_URL = boilerPlateIsActive
  ? process.env.VUE_APP_DRAGON_TIGER_API
  : process.env.VUE_APP_API;
const axiosInsDragonTiger = axios.create({
  headers: {
    'Content-type': 'application/json; charset=utf-8',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': 'Content-Type',
    'cache-control': 'no-cache',
  },
  // You can add your headers here
  // ================================
  baseURL: API_URL,
  // timeout: 1000,

  validateStatus: function (status) {
    return status >= 200 && status < 500; // defecto
  },
});
let user = JSON.parse(localStorage.getItem('user'));
let token = localStorage.getItem('tokenSession');
if (user) {
  axiosInsDragonTiger.defaults.headers.common['Authorization'] =
    'Bearer ' + user.token;
}
if (token) {
  axiosInsDragonTiger.defaults.headers.common['x-token'] = token;
  axiosInsDragonTiger.defaults.headers.common['authentication-x-token'] = token;
}

export default axiosInsDragonTiger;
